import React, { Component } from 'react'
import PropTypes from 'prop-types';

const style = {
    cursor: 'pointer'
}

const SecondaryStyleCss = {

    container : {
    
        backgroundColor: '#f9f9f9',
        display: 'flex',
        flexDirection: 'row',
        marginBottom: '20px',
        cursor: 'pointer'
    },
    leftSide: {
        height: 'auto',
        width: '5px',
        backgroundColor: '#A52A2A'
    },
    rightSide: {
        padding: '10px',
        paddingLeft: '25px'
    },
    newText: {
        fontWeight: 300
    }
    

}

class TitleStyle extends Component {
    state = {
        width: 20
    }

    onMouseOver = () => {
        this.setState({
            width: 80
        })
    }

    onMouseOut = () => {
        this.setState({
            width: 20
        })
    }
    render() {
        let title = this.props.title;
        let title_head = '';
        let title_tail = '';

        if (title !== undefined) {
            let title_arr = title.split(' ');
            if (title_arr.length === 1) {
                title_head = title_arr[0];
            } else {
                title_head = title_arr[0];
                title_arr.splice(0, 1);
                title_tail = title_arr.join(' ');
            }
        }

        return (
            <div style={style}
                onMouseOver={this.onMouseOver}
                onMouseOut={this.onMouseOut}
            >
                <div className="styled-title">
                    <h5>
                        <b><span>{title_head}</span> {title_tail}</b>
                    </h5>
                    {/* <div style={{ width: this.state.width, transition: 'all 0.3s ease-in-out' }}></div> */}
                </div>
            </div>
        )
    }
}

TitleStyle.propTypes = {
    title: PropTypes.string
}

export default TitleStyle;


export const SecondaryStyle = (props) => {
    return (
        <div style={SecondaryStyleCss.container}>
            <div style={SecondaryStyleCss.leftSide}>

            </div>
            <div style={SecondaryStyleCss.rightSide}>
               <h5 style={SecondaryStyleCss.newText}>
                    {props.title}
                </h5> 
            </div>
            
        </div>
    )
}
